import React from "react";

import "./About.scss";
const About = () => {
  return (
    <article className="about">
      <figure>
        <img
          src="/image/about.jpeg"
          alt="profile"
        />
      </figure>
      <div>
        <h1>ABOUT</h1>
        {/* <p>Wellcome to my perspective of world. Finished my Diploma in Fashion Photography in 2016 at JD INSTITUTE OF FASHION TECHNOLOGY , BANGALORE. Experience of 3+years in portraits,weddings, fashion, corporate events and so on . Based in Bangalore,but love to travel and work .Having descent knowledge in Photoshop and Lightroom to give my final enhance to the image.Storytelling is one of the strongest mode of way representing a picture which I'm always drawn too. I Really take pride in capturing the true emotions and personality of people and subjects I photograph .I appreciate the people I meet n portray them. These story telling pictures makes them memorable and iconic it's my strongest asset. 
        I specialize in portraits , weddings , Fashion , Events and travel portraits. Look forward to meeting you and work with you .</p> */}
        <p>
        Welcome to my perspective of world. Finished my Diploma in Fashion Photography in 2016 at JD INSTITUTE OF FASHION TECHNOLOGY , BANGALORE. Experience of 3+years in portraits,weddings, fashion, corporate events and so on. Based in Bangalore, but love to travel and work. Having descent knowledge in Photoshop and Lightroom to give my final enhance to the image. Storytelling is one of the strongest mode of representing a picture which I have always drawn too. I really take pride in capturing the true emotions and personality of people and subjects, I photograph. I appreciate the people who I meet and portray them. These story telling pictures make them memorable and iconic which is the strongest asset for me. I specialize in portraits, weddings,  fashion, events and travel portraits. Looking forward to meet and work with you.
        </p>
        <p>
        Thank you ..
        </p>
      </div>
    </article>
  );
};

export default About;
